/* eslint-disable */
import React from 'react';

import SparkOne from './SelectSVG/SparkOne';
import SparkOneGreen from './SelectSVG/SparkOneGreen';
import MarketingDigital from './SelectSVG/MarketingDigital';
import Desenvolvimento from './SelectSVG/Desenvolvimento';
import CertificadoDigital from './SelectSVG/CertificadoDigital';
import Facebook from './SocialIconsSVG/Facebook';
import Instagram from './SocialIconsSVG/Instagram';
import Linkedin from './SocialIconsSVG/Linkedin';
import Wquarks from './LogoSVG/Wquarks';

import FinanceIcon from './ServiceSVG/financeSVG';
import ReportsIcon from './ServiceSVG/reportsSVG';
import AppIcon from './ServiceSVG/appSVG';
import SoftwaresIcon from './ServiceSVG/softwaresSVG';
import WebsitesIcon from './ServiceSVG/websitesSVG';

import styled, { css, keyframes } from 'styled-components';


const WrapperStyles = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
  z-index: 0;
`;

export const IconStyles = {
  width: '100%',
  zIndex: 0,
};

export const SocialIconStyles = {
  width: '85%',
  paddingLeft: '15%',
};

const SelectIcon = props => {
  const { icon, label, color } = props;

  let Icon;
  if (icon === 'SparkOne') {
    Icon = <SparkOne label={label} />;
  } else if (icon === 'SparkOne Green') {
    Icon = <SparkOneGreen label={label} />;
  } else if (icon === 'Marketing Digital') {
    Icon = <MarketingDigital label={label} />;
  } else if (icon === 'Desenvolvimento') {
    Icon = <Desenvolvimento label={label} />;
  } else if (icon === 'Certificado Digital') {
    Icon = <CertificadoDigital label={label} />;
  } else if (icon === 'facebook') {
    Icon = <Facebook color="#FFF" label={label} />;
  } else if (icon === 'instagram') {
    Icon = <Instagram color="#FFF" label={label} />;
  } else if (icon === 'linkedin') {
    Icon = <Linkedin color="#FFF" label={label} />;
  } else if (icon === 'wquarks') {
    Icon = <Wquarks
            iconStyles={{ width:'100%' }}
            color="#FFF"
            label={label}
          />;
  }else if (icon === 'finance') {
    Icon = <FinanceIcon
              iconStyles={{ width:'100%' }}
              color="#FFF"
              label={label}
            />;
  }else if (icon === 'reports') {
    Icon = <ReportsIcon
            iconStyles={{ width:'100%' }}
            color="#FFF"
            label={label}
          />;
  }else if (icon === 'app') {
    Icon = <AppIcon
            iconStyles={{ width:'100%' }}
            color="#FFF"
            label={label}
          />;
  }else if (icon === 'softwares') {
    Icon = <SoftwaresIcon
            iconStyles={{ width:'100%' }}
            color="#FFF"
            label={label}
          />;
  }else if (icon === 'websites') {
    Icon = <WebsitesIcon
            iconStyles={{ width:'100%' }}
            color="#FFF"
            label={label}
          />;
  }

  return <WrapperStyles >{Icon}</WrapperStyles>;
};

export default SelectIcon;



// WEBPACK FOOTER //
// ./src/components/UI/Img/SelectIcon.jsx